import Icon from './icon.element.js';

export default Icon;

Icon.define('wje-icon', Icon);
